import "./RegistrationForm.css";
import { TopSection } from "../../TopSection/TopSection";
import { BottomSection } from "../../BottomSection/BottomSection";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import axios from "axios";
import { useState } from "react";

export const RegistrationForm = ({setRegistrationStep,setUserData}) => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();
  const [error ,setErrors] = useState('');
  const [loading,setLoading] = useState(false);
  const onSubmit = (data) => {
    console.log(data);
    setUserData(data);
    setLoading(true);
    axios.post('https://mfnj3t4tqm.us-east-1.awsapprunner.com/api/uloggedin/user/check-registration',
      {
        phoneNumber : data?.mobileNumber
      }
    )
    .then((resp)=>{
      console.log(resp.data)
      setLoading(false);
      setRegistrationStep(1)
    })
    .catch((err)=>{
      setLoading(false);
      console.log("err",err?.response?.data)
      setErrors(err?.response?.data);
      setTimeout(()=>{
        setErrors('')
      },2000)
    })
  };

  console.log(watch("example")); // watch input value by passing the name of it
  return (
    <>
      <div className="reg-form-container">
        <TopSection />
        <form className="reg-middle-section" onSubmit={handleSubmit(onSubmit)}>
          <h2>User Registration</h2>
          <hr />
          <input
            type="text"
            id="firstName"
            name="firstName"
            placeholder="First Name"
            {...register("firstName", { required: true })}
            className={`input-field ${errors.firstName ? "error-para" : ""}`}
          />

          <input
            type="text"
            id="lastName"
            name="lastName"
            placeholder="Last Name"
            {...register("lastName", { required: true })}
            className={`input-field ${errors.lastName ? "error-para" : ""}`}
          />

          <input
            type="number"
            id="mobileNumber"
            name="mobileNumber"
            placeholder="Mobile Number"
            onWheel={(e) => e.target.blur()}
            {...register("mobileNumber", { required: true })}
            className={`input-field ${errors.mobileNumber ? "error-para" : ""}`}
          />

          <select
            className="select-field"
            id="location"
            name="location"
            {...register("location")}
          >
            <option value="" disabled selected>
              Location
            </option>
            <option value="other">Other</option>
          </select>
          <button className="submit-btn" type="submit">
            {loading?'Loading...':  'Submit'}
          </button>
          {
            error &&
            <p style={{marginTop:10,fontSize:13,color:'red'}}>{error}</p>
          }
          <Link to="/forgot-password" className="forget-p">
            <p >Forget Password ?</p>
          </Link>
          <BottomSection />
        </form>
      </div>
    </>
  );
};
